var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"full-height accent"},[_c('top-bar'),_c('sidemenu',{ref:"menu"}),_c('v-main',{staticClass:"below-top-bar"},[_c('router-view')],1),_c('Footer'),_c('error-dialog')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }